// import React from 'react';
// import { styled } from '@mui/material/styles';
// import Switch from '@mui/material/Switch';
// import './coupon.css';

// const IOSSwitch = styled((props) => (
//     <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
// ))(({ theme }) => ({
//     width: 42,
//     height: 26,
//     padding: 0,
//     '& .MuiSwitch-switchBase': {
//         padding: 0,
//         margin: 2,
//         transitionDuration: '300ms',
//         '&.Mui-checked': {
//             transform: 'translateX(16px)',
//             color: '#fff',
//             '& + .MuiSwitch-track': {
//                 backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
//                 opacity: 1,
//                 border: 0,
//             },
//             '&.Mui-disabled + .MuiSwitch-track': {
//                 opacity: 0.5,
//             },
//         },
//         '&.Mui-focusVisible .MuiSwitch-thumb': {
//             color: '#33cf4d',
//             border: '6px solid #fff',
//         },
//         '&.Mui-disabled .MuiSwitch-thumb': {
//             color:
//                 theme.palette.mode === 'light'
//                     ? theme.palette.grey[100]
//                     : theme.palette.grey[600],
//         },
//         '&.Mui-disabled + .MuiSwitch-track': {
//             opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
//         },
//     },
//     '& .MuiSwitch-thumb': {
//         boxSizing: 'border-box',
//         width: 22,
//         height: 22,
//     },
//     '& .MuiSwitch-track': {
//         borderRadius: 26 / 2,
//         backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
//         opacity: 1,
//         transition: theme.transitions.create(['background-color'], {
//             duration: 500,
//         }),
//     },
// }));

// const CouponCard = (props) => {

//     const handleStatusChange = (e) => {
//         let { id } = props;
//         let status = e.target.checked === true ? "active" : "inactive";
//         props.EditCoupon({ id, status })
//     }

//     const DeleteStatus = () => {
//         let { id } = props;
//         let status = 'deleted';
//         props.EditCoupon({ id, status })
//     }

//     return (
//         <div className='coupon-card'>
//             <div className='coupon-item-container'>
//                 <div className='coupon-heading'>
//                     <span className='coupon-name'>
//                         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr8"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.1451 12.6214C22.076 12.4782 22.0401 12.3212 22.0401 12.1621C22.0401 12.003 22.076 11.8459 22.1451 11.7028L22.9259 9.92488C23.0863 9.57143 23.1694 9.1875 23.1694 8.79896C23.1694 8.41042 23.0863 8.0264 22.9259 7.67295C22.774 7.32819 22.5529 7.01862 22.2767 6.76369C22.0004 6.50876 21.6747 6.31395 21.3202 6.19137L19.5082 5.50981C19.3619 5.45094 19.229 5.36279 19.1176 5.25073C19.0062 5.13868 18.9185 5.00505 18.86 4.85791L18.1676 3.02077C18.0307 2.66225 17.8226 2.33548 17.5561 2.06042C17.2896 1.78536 16.9702 1.56775 16.6174 1.42082C16.2646 1.27389 15.8857 1.20072 15.5039 1.20578C15.122 1.21085 14.7452 1.29407 14.3963 1.4503L12.6286 2.26515C12.3356 2.38381 12.0083 2.38381 11.7152 2.26515L9.94745 1.4503C9.59784 1.29166 9.21969 1.20656 8.8362 1.20027C8.45271 1.19397 8.07197 1.2666 7.7174 1.41368C7.36283 1.56076 7.04191 1.77917 6.77434 2.05554C6.50677 2.3319 6.29819 2.66038 6.16144 3.02077L5.48381 4.85791C5.42527 5.00505 5.33762 5.13868 5.22621 5.25073C5.11479 5.36279 4.98191 5.45094 4.83562 5.50981L3.00893 6.19137C2.65059 6.3289 2.32398 6.53863 2.04919 6.80773C1.7744 7.07683 1.55722 7.39964 1.41098 7.75623C1.26474 8.11283 1.19252 8.49566 1.19879 8.88134C1.20505 9.26703 1.28966 9.64743 1.4474 9.99904L2.25761 11.7769C2.37559 12.0716 2.37559 12.4007 2.25761 12.6954L1.4474 14.4733C1.29097 14.8253 1.21011 15.2064 1.21011 15.5919C1.21011 15.9774 1.29097 16.3586 1.4474 16.7105C1.59461 17.0558 1.81229 17.3661 2.08637 17.6213C2.36045 17.8766 2.68479 18.071 3.03838 18.1921L4.86507 18.8885C5.01136 18.9474 5.14428 19.0354 5.2557 19.1475C5.36712 19.2595 5.45472 19.3933 5.51326 19.5404L6.19094 21.3627C6.3929 21.8991 6.75137 22.3615 7.21933 22.6894C7.68728 23.0172 8.24285 23.1952 8.81314 23.1999C9.21463 23.2017 9.6117 23.1158 9.97689 22.948L11.7447 22.1332C11.8882 22.0674 12.0437 22.0321 12.2014 22.0294C12.3606 22.0335 12.5168 22.0739 12.658 22.1479L14.4258 22.9332C14.7748 23.0942 15.1541 23.1776 15.5381 23.1776C15.922 23.1776 16.3013 23.0942 16.6503 22.9332C17.0067 22.7889 17.3288 22.5704 17.5954 22.292C17.862 22.0137 18.067 21.6819 18.1971 21.3182L18.8895 19.4959C18.948 19.3488 19.0356 19.2151 19.147 19.1031C19.2584 18.991 19.3914 18.9029 19.5377 18.844L21.3496 18.1477C21.7042 18.0251 22.0298 17.8302 22.3061 17.5753C22.5824 17.3204 22.8034 17.0109 22.9553 16.6661C23.1155 16.3152 23.1984 15.9337 23.1984 15.5475C23.1984 15.1614 23.1155 14.7799 22.9553 14.4289L22.1451 12.6214ZM7.46953 9.16241C7.46953 8.95425 7.62796 8.82102 7.78024 8.82102H16.6166C16.7689 8.82102 16.9273 8.95425 16.9273 9.16241V15.2374C16.9273 15.4456 16.7689 15.5788 16.6166 15.5788H7.78024C7.62796 15.5788 7.46953 15.4456 7.46953 15.2374V9.16241ZM7.78024 7.4788C6.84804 7.4788 6.12732 8.25219 6.12732 9.16241V15.2374C6.12732 16.1476 6.84804 16.921 7.78024 16.921H16.6166C17.5488 16.921 18.2695 16.1476 18.2695 15.2374V9.16241C18.2695 8.25219 17.5488 7.4788 16.6166 7.4788H7.78024ZM13.2969 12.1394C13.2969 12.8859 12.6917 13.4911 11.9451 13.4911C11.1986 13.4911 10.5934 12.8859 10.5934 12.1394C10.5934 11.3928 11.1986 10.7876 11.9451 10.7876C12.6917 10.7876 13.2969 11.3928 13.2969 12.1394Z" fill="#17B31B"></path></svg>
//                         <span className='name'>
//                             {`${props.couponCode}`}
//                         </span>
//                     </span>
//                     <span className='switch-button'>
//                         <IOSSwitch
//                             sx={{ m: 1 }}
//                             checked={props.status === 'active' ? true : false}
//                             onChange={(e) => handleStatusChange(e)} />
//                     </span>
//                 </div>
//                 <div className='coupon-description'>
//                     {
//                         props.type === 1 ?
//                             `${props.discountPercent} % off on all orders above ₹${props.minPurAmt} upto ₹${props.disAmt}`
//                             :
//                             props.type === 2 ?
//                                 `₹${props.disAmt} off on all orders above ₹${props.minPurAmt}`
//                                 :
//                                 props.type === 3 ?
//                                     `Buy ${props.buyItemNo} Get ${props.getItemNo} free`
//                                     :
//                                     props.type === 4 &&
//                                     `Free delivery on all orders`

//                     }
//                 </div>
//                 <div className='coupon-divider' />
//                 <div className='status'>
//                     <span className='times-used-div'>
//                         <span className='times-used-div-heading'>
//                             {'TIMES USED'}
//                         </span>
//                         <span className='times-used-div-desc'>
//                             {props.appliedCount === null ? 0 : `${props.appliedCount}`}
//                         </span>
//                     </span>
//                     <span className='times-used-div'>
//                         <span className='times-used-div-heading'>
//                             {'Uses per customer'}
//                         </span>
//                         <span className='times-used-div-desc'>
//                             {`${props.custUseCount}`}
//                         </span>
//                     </span>
//                 </div>
//                 <div>
//                     <span>
//                     </span>
//                     <p role='button' style={{ color: 'red', cursor: 'pointer' }} onClick={DeleteStatus}>Delete</p>
//                 </div>
//             </div>
//             <div className='circle circle1' />
//             <div className='circle circle2' />
//         </div>
//     )
// }

// export default CouponCard

//new code
import React, { useEffect, useState } from "react";
import CustomCard from "../Commoncomponents/card";
import Couponicon from "../../utils/Icon/Coupon.svg";
import CustomToggleButton from "../Commoncomponents/toggleButton";
import Delete from "../../utils/Icon/delete.svg";

import "./index.css";
import {
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "../MUIComponents/index";
import {
  HeaderFontSize_25,
  contentFontSize_15,
  contentFontSize_18_xs_13,
  HeaderFontSize_24_xs_17,
} from "../Typography/index";
import { message } from "antd";
import CustomDialog from "../Commoncomponents/dialog";
import {Dialog} from "../MUIComponents/index";
import {contentFontSize_16_xs_10} from '../Typography/index';
import { useDispatch } from "react-redux";

function CouponCard(props) {
  const [couponDelete,setCouponDelete]=useState(false);

  const dispatch=useDispatch();

  const handleCouponDelete=()=>{
    setCouponDelete(true)
  }
  const handleCouponDeleteFalse=()=>{
    setCouponDelete(false)
  }

  // useEffect(()=>{
  //   if(props.EditingCouponssuccess){
  //     message.success({
  //       content: " Coupon Deleted Successfully",
  //       className: "custom-class",
  //       style: {
  //         marginTop: "10vh",
  //         marginLeft: "15vw",
  //       },
  //       duration: 3.5,
  //     });
  //   }

  // },[props.EditingCouponssuccess])

  const theme = useTheme();
  const upXlmatch = useMediaQuery(theme.breakpoints.up("xl"));
  const uplgmatch = useMediaQuery(theme.breakpoints.up("lg"));
  const xlmatch = useMediaQuery(theme.breakpoints.down("xl"));
  const lgmatch = useMediaQuery(theme.breakpoints.down("lg"));
  const mdmatch = useMediaQuery(theme.breakpoints.down("md"));
  const smmatch = useMediaQuery(theme.breakpoints.down("sm"));
  const xsmatch = useMediaQuery(theme.breakpoints.down("xs"));

  const customStyles = {
    toggleBtnCirStyle: {
      display: "inline-block",
      border: "1px solid transparent",
      borderRadius: "50px",
      width: mdmatch ? "90px" : "120px",
      height: mdmatch ? "28px" : "39px",
      padding: "5px",
      cursor: "pointer",
      boxSizing: "border-box",
    },
    boxStyle: {
      display: "flex",
      justifyContent: "space-around",
    },
    disOfflineStyle: {
      display: "flex",
      justifyContent: "space-between",
      aliginItems: "center",
    },
    offlineCirStyle: {
      display: "block",
      height: mdmatch ? "16.25px" : "26.25px",
      width: mdmatch ? "16.25px" : "26.25px",
      borderRadius: "50%",
      backgroundColor: "gray",
      marginRight: "15px",
    },
    disOnlineStyle: {
      display: "flex",
      justifyContent: "space-between",
      aliginItems: "center",
    },
    onlineCirStyle: {
      display: "block",
      height: mdmatch ? "16.25px" : "26.25px",
      width: mdmatch ? "16.25px" : "26.25px",
      borderRadius: "50%",
      backgroundColor: "#72B01D",
      marginLeft: "15px",
    },
    active: {
      display: "none",
    },
  };

  const handleStatusChange = (status1, id) => {
  
    if (status1 === "active") {
     
      status1 = "inactive";
      const newStatus = status1;
     
      const status = newStatus;
      props.EditCoupon({ id, status });
      message.success({
        content: "Coupon status changed to inactive successfully",
        className: "custom-class",
        style: {
          marginTop: "10vh",
          marginLeft: "15vw",
        },
        duration: 1,
      });
    } else if (status1 === "inactive"||status1==="created") {
      status1 = "active";
      const newStatus = status1;

     
      const status = newStatus;
      props.EditCoupon({ id, status });
      message.success({
        content: "Coupon status changed to active successfully",
        className: "custom-class",
        style: {
          marginTop: "10vh",
          marginLeft: "15vw",
        },
        duration: 1,
      });
    }
  };

  const DeleteStatus = () => {
    let { id } = props;
    let status = "deleted";
    props.EditCoupon({ id, status });

    message.success({
      content: " Coupon Deleted Successfully",
      className: "custom-class",
      style: {
        marginTop: "10vh",
        marginLeft: "15vw",
      },
      duration: 3.5,
    });
  
  };
  
  return (
    <>
      <CustomCard
        height={"100%"}
        width={"100%"}
        padding="0px"
        background={props.status==="created" || props.status==="inactive"?"#8B8989": "black"}
        borderRadius={"30px"}
        boxShadow="none"
        // position="relative"
        sx={{
          zIndex: "1",
         
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          borderRadius: "30px",
          boxShadow: "0 2px 6px #1a181e0a",
          overflow: "hidden",
        }}
        className="coupon-card"
      >
        <div style={{ position: "relative",height:"80%" }}>
          <div
            style={{
              display: "flex",
              position: "relative",
              padding: uplgmatch ? "25px 50px" : "25px 25px",
              borderTop: "1px solid #CFE4B2",
              borderLeft: "1px solid #CFE4B2",
              borderRight: "1px solid #CFE4B2",
              borderTopLeftRadius: "30px",
              borderTopRightRadius: "30px",
              // paddingBottom: "0px",

              flex: 1,
            }}
          >
            <div style={{display:"flex",width:"100%",height:"100%"}}>
            <div className="coupon-item-container">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div className="coupon-heading">
                  <span className="coupon-name">
                    <Typography fontSize={HeaderFontSize_25} className="name" >
                      {`${props.couponCode}`}
                    </Typography>
                  </span>
                 
                </div>
                <Typography
                  fontSize={contentFontSize_15}
                  className="coupon-description"
                  style={{ height: mdmatch ? "25px" : "35px" }}
                >
                  {props.type === 1
                    ? `${props.discountPercent} % off on all orders above ₹${props.minPurAmt} upto ₹${props.disAmt}`
                    : props.type === 2
                    ? `₹${props.disAmt} off on all orders above ₹${props.minPurAmt}`
                    : props.type === 3
                    ? `Buy ${props.buyItemNo} Get ${props.getItemNo} free`
                    : props.type === 4 && `Free delivery on all orders`}

                  <span>
                    <img
                      src={Couponicon}
                      alt="coupon"
                      width={mdmatch ? "14.11px" : "22.11px"}
                      height={mdmatch ? "14.11px" : "22.11px"}
                    />
                  </span>
                </Typography>
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "30px",
                  marginTop: mdmatch ? "15px" : "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <Typography
                    className="times-used-div-heading"
                    fontSize={contentFontSize_18_xs_13}
                  >
                    Times Used
                  </Typography>
                  <Typography
                    className="times-used-div-desc"
                    fontSize={contentFontSize_18_xs_13}
                  >
                    {props.appliedCount === null ? 0 : `${props.appliedCount}`}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "2px solid green",
                  }}
                ></div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <Typography
                    className="times-used-div-heading"
                    fontSize={contentFontSize_18_xs_13}
                  >
                    Use Per Customer
                  </Typography>
                  <Typography
                    className="times-used-div-desc"
                    fontSize={contentFontSize_18_xs_13}
                  >
                  
                    {props.custUseCount}
                  </Typography>
                </div>
              </div>
            </div>
            <div className="card-off">
              <div>
                <Typography
                  style={{
                    writingMode: "vertical-lr",
                    color: "#BDBDBD",
                    display:"flex",
                    justifyContent:"center",
                    fontFamily: "Nunito",
                    fontWeight: "800",
                    letterSpacing: "2px",
                  }}
                  fontSize={HeaderFontSize_24_xs_17}
                >
              
                   {props.type === 1 && `${props.discountPercent}% OFF`}
    {props.type === 2 && `FLAT OFF`}
    {props.type === 3 && `B ${props.buyItemNo} G ${props.getItemNo}`}
    {props.type === 4 && `DELIVERY OFF`}
                </Typography>
              </div>
            </div>
          </div>
          </div>
          <div className="circle1">
    <div className="half1">
        <div className="content1" style={{background:"transparent"}}></div>
    
        <div className="content1" style={{background:"rgb(244, 245, 249)"}}></div>
    </div>
</div>

<div className="circle2">
    <div className="half2">
        <div className="content2" style={{background:"rgb(244, 245, 249)"}}></div>
    
        <div className="content2" style={{background:"transparent"}}></div>
    </div>
</div>
        </div>
        <div
          className="card-bottom"
          style={{ padding: mdmatch ? "10px 20px" : "10px 30px"}}
        >
          <div className="toggle">
            <CustomToggleButton
              initialOnline={props.status === "active" ? true : false}
              onClick={() => handleStatusChange(props.status, props.id)}
              textOne="Active"
              textTwo="Inactive"
              textFont={mdmatch ? "13px" : "19px"}
              {...customStyles}
            ></CustomToggleButton>
          </div>
          <div className="remaining">
            <Typography fontSize={contentFontSize_18_xs_13}>
              Remaining Days - {props.remainingDays}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor:"pointer"
            }}
          >
            <img
              src={Delete}
              alt="Delete"
              onClick={handleCouponDelete}
              height={mdmatch ? "16.88px" : "24.88px"}
              width={mdmatch ? "14.88px" : "22.11px"}
            />
          </div>
        </div>
      </CustomCard>

      {couponDelete && (
          <div>
            <Dialog
              width="100%"
              // maxHeight="50%"
              borderRadius="20px"
              open={couponDelete}
              onClose={handleCouponDeleteFalse}
              titleAlign="center"
              padding="0px"
              showCloseButton={false}
            >
              <div style={{textAlign:"center"}}>
                <Typography
                  style={{
                    padding:"24px 20px",
                    boxSizing: "border-box",
                    color:"rgb(139, 137, 137)",
                    fontFamily:'Roboto',
                    fontWeight:"900"
                  }}
                  className="para-font-1"
                  fontSize={contentFontSize_18_xs_13}
                >
                  Do you want to delete the Coupon?
                </Typography>
              </div>
 
              <div style={{ display: "flex", justifyContent: "space-evenly", padding:"5px 40px 20px 40px"}}>
                <div onClick={handleCouponDeleteFalse}><Typography className="delete" style={{ cursor:"pointer",fontFamily:'Roboto',fontWeight:"900",color:"rgb(139, 137, 137)",display:"flex",alignItems:"center",justifyContent:"center",height:"100%"}} fontSize={contentFontSize_16_xs_10} >Cancel</Typography></div>
                <div>|</div>
                <div   onClick={DeleteStatus}><Typography className="delete"  style={{color:"red", cursor:"pointer",fontFamily:"Roboto",fontWeight:"900",display:"flex",alignItems:"center",justifyContent:"center",height:"100%"}} fontSize={contentFontSize_16_xs_10}>Delete</Typography></div>
              </div>
            </Dialog>
          </div>
        )}
    </>
  );
}

export default CouponCard;
